import { createContext, useContext } from 'react';
import { AppContext } from '../Context';

export const ConsultaEvaluacionContext = createContext(false);

export const esAlumnoDeEvaluacion = (usuario) => Boolean(usuario)
  && usuario.teacher !== true
  && usuario.isMaster !== true
  && usuario.isSuperAdmin !== true;

// También protege los ejercicios abiertos fuera del modal compartido.
export const useModoConsultaEvaluacion = () => {
  const consultaSolicitada = useContext(ConsultaEvaluacionContext);
  const { currentUser } = useContext(AppContext);
  return consultaSolicitada || !esAlumnoDeEvaluacion(currentUser);
};
